import { Locale } from 'dayjs/locale/base';
import dayjsEn from 'dayjs/locale/en';
import dayjsCh from 'dayjs/locale/zh-cn';
import dayjsRu from './dayjsRu';
import dayjsKz from './dayjsKz';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import dayjs from 'dayjs';

export const localWeekDayToIndexWeekday: Record<number, number> = {
  0: 1,
  1: 2,
  2: 3,
  3: 4,
  4: 5,
  5: 6,
  6: 0,
};

export const ns = 'common';

export const dayjsLocales: Record<string, Locale> = {
  ru: dayjsRu,
  kz: dayjsKz,
  en: dayjsEn,
  ch: dayjsCh,
};

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    fallbackLng: 'ru',
    supportedLngs: ['ru', 'kz', 'en', 'ch'],
    interpolation: {
      escapeValue: false,
    },
    debug: false,
    defaultNS: ns,
  })
  .then(() => dayjs().locale(dayjsLocales[i18n.language]));

export default i18n;
